<script setup lang="ts">
definePageMeta({
  middleware: 'auth',
  validate: async ({ query }) => {
    return typeof query.redirect === 'undefined' ||
      (typeof query.redirect === 'string' && query.redirect.startsWith('/') && !query.redirect.match(/^([/\\]\s*){2,}[^/\\]/))
  },
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/u/moje-konto',
  },
})

useHead({
  titleTemplate: 'Logowanie - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ]
})

const { query } = useRoute()
</script>

<template>
  <div class="md:container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name: 'Zaloguj się' }]" class="px-[15px] md:px-0" />
    <div class="flex flex-col md:flex-row justify-around my-[30px]">
      <div class="md:w-1/3 px-[15px] md:px-0">
        <h2 class="text-20 md:text-32 font-bold mb-[15px]">
          Zaloguj się
        </h2>
        <UserLoginForm :redirect="query.redirect?.toString()" />
        <NuxtLink to="/u/przypomnienie-hasla" class="text-gray-500 text-14 underline">
          Przypomnij hasło
        </NuxtLink>
        <div class="flex items-center relative text-gray-500 mb-[30px] before:flex-1 before:h-px before:bg-secondary after:flex-1 after:h-px after:bg-secondary">
          <span class="flex-wrap mx-[50px]">lub</span>
        </div>
        <div class="flex flex-col gap-[10px]">
          <UserGoogleLogin :redirect="query.redirect?.toString()" />
          <UserFacebookLogin :redirect="query.redirect?.toString()" />
        </div>
      </div>
      <div class="md:w-1/2 flex flex-col md:items-center mt-[50px]">
        <div class="md:w-2/3 px-[15px] md:px-0">
          <h2 class="text-20 md:text-32 font-bold mb-[15px]">
            Nie masz konta?
          </h2>
          <NuxtLink to="/u/rejestracja" class="btn btn-secondary btn-lg">
            <span>Zarejestruj się</span>
            <i class="icon-arrow-button text-[10px]" />
          </NuxtLink>
        </div>
        <div class="w-full flex justify-center bg-secondary mt-[50px] md:mt-[90px] px-[15px] md:px-0 py-[20px] md:py-[40px]">
          <div class="w-full md:w-2/3">
            <h2 class="text-20 md:text-32 font-bold text-white">
              Jesteś wykonawcą?
            </h2>
            <span class="text-12 md:text-16 font-light text-white">Przejdź do systemu rezerwacyjnego</span>
            <NuxtLink to="/system-rezerwacyjny" class="btn btn-white btn-lg text-14 md:text-16 mt-[20px] md:mt-[30px]">
              <span>Przejdź</span>
              <i class="icon-arrow-button text-[10px]" />
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
